import React, { useState, useEffect } from "react";
import {
  CONFIRMATION_DELETE_HEADER,
  CONFIRMATION_DELETE_MESSAGE,
} from "../../../App.config";
const ConfirmationPopUpModalComponent = (props) => {
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if(props.userAuthReducer)
      setSuccessMessage(props.userAuthReducer.successMessageForBackupUserAssigned);
  }, [props && props.userAuthReducer && props.userAuthReducer.successMessageForBackupUserAssigned])
  return (
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {props.context.t(
              "STD.label.delete.delete-Confirmation-modal-header"
            )}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => props.closeRemoveModal()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div>
            <span>
              {
                props.confirmationMessage
                  ?
                  props.confirmationMessage
                  :
                  props.context.t(
                    "STD.label.delete.delete-Confirmation-modal-message"
                  )
              }

            </span>
          </div>
          <div>
          {successMessage && <span className="text-danger">
              (
            {
                successMessage
              }
            )
          </span>}
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger"
            data-dismiss="modal"
            onClick={() => {
              props.resetsuccessMessageForBackupUserAssigned();
              props.closeRemoveModal()
            }}
          >
            {props.context.t(
              "STD-Employer-Statement.form.Employee-Details.Toggle.No.Common"
            )}
          </button>
          <button
            onClick={() => {
              props.onYesClick();
              props.resetsuccessMessageForBackupUserAssigned();
            }}
            type="button"
            className="btn btn-primary"
          >
            {props.context.t(
              "STD-Employer-Statement.form.Employee-Details.Toggle.Yes.Common"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
export default ConfirmationPopUpModalComponent;
